export const PIE_COLORS = ['#1976d2', '#26a69a', '#8c9eff', '#f9a825', '#ffd740', '#86d7c3'];
